import React, { useContext, useEffect, useState } from 'react'
import { GlobalAgGridTable } from '../../Deal/AgGridReactComponent/GlobalAgGridTable';
import { AppDataRequired } from '../../../App';
import moment from 'moment';
import AwsServerService from '../../../common/util/AwsServerService';
import swal from 'sweetalert';
import './SecurityControls.css'
import { Button, Col, Input, message, Modal, Row, Select } from 'antd';
import ModulePermissions from './ModulePermissions';
import TextArea from 'antd/es/input/TextArea'; 
import RolesHierarchy from './RolesHierarchy';
import { Tabs } from 'antd'; // Add this at the top with other imports
import { useSelector } from 'react-redux';

export default function ApplicationProfiles() {
    let userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const { AllUsers } = useContext(AppDataRequired);
    const accessContext = useSelector(state => state.UserContext.accessContext);
    const userMap = AllUsers.reduce((acc, user) => {
        acc[user.email.trim().toLowerCase()] = user.full_name;
        return acc;
        }, {});
        const { TabPane } = Tabs; 
          const [activeTab, setActiveTab] = useState("1");
    const fetchProfiles = () => {
        return AwsServerService.GetApplicationProfiles()
            .then((res) => {
                const profileData = accessContext?.profile?.name == "Administrator" ? res?.data
                        : res?.data?.filter(profile => profile?.PROFILE_NAME == accessContext?.profile?.name);
                setProfilesData(profileData);
                setCacheProfilesData(profileData);
            })
            .catch(err => console.error(err));
    };
    useEffect(()=>{
        fetchProfiles();
    },[])
    const [profilesData, setProfilesData] =  useState([]);
    const [cacheProfilesData, setCacheProfilesData] =  useState([]);
    const [isEditProfileAccess, setIsEditProfileAccess] = useState({isTrue:false, Profile:{}});
    const [openCreateModal, setOpenCreateModal] = useState({data:{PROFILE_NAME:'',DESCRIPTION:'',cloneProfile:''},open:false,type:"create"});

    const profilenameCellRenderer = (params) => { 
    let btnDiv = document.createElement("div");
                btnDiv.classList.add("global-action-btn-for-tables"); 
                let editBtn = document.createElement('button');
                editBtn.classList.add("add")
                editBtn.innerText = params.PROFILE_NAME
                editBtn.id = params.ROWID;
                editBtn.addEventListener('click', (e) => {   
                        setIsEditProfileAccess({isTrue:true,Profile:params})
                })
                
                btnDiv.appendChild(editBtn);
    return btnDiv;
};

    const actionListCellRenderer = (params) => { 
                let btnDiv = document.createElement("div");
                btnDiv.classList.add("global-action-btn-for-tables"); 
                let editBtn = document.createElement('button');
                editBtn.classList.add("add")
                editBtn.innerText = "Edit"
                editBtn.id = params.ROWID;
                editBtn.addEventListener('click', (e) => {  
                    let Rowid = e.currentTarget.id;
                    if (params.ROWID == Rowid) {
                        setOpenCreateModal({ open: true, data: {PROFILE_NAME: params.PROFILE_NAME,DESCRIPTION: params.DESCRIPTION, ROWID: params.ROWID}, type: "edit" });
                    }
                })
                let deleteBtn = document.createElement('button');
                deleteBtn.classList.add("add")
                deleteBtn.style.color = "red";
                deleteBtn.innerText = "Delete";
                deleteBtn.id = params.ROWID;
                deleteBtn.addEventListener('click', (e) => {
                    let Rowid = e.currentTarget.id;
                    swal({
                        title: "Warning!",
                        text: `Are you sure you want to delete the Profile?`,
                        icon: "warning",
                        buttons: {
                            cancel: true,
                            confirm: {
                                text: "Proceed",
                                value: true,
                            },
                        },
                        dangerMode: true,
                    }).then((willDelete) => {
                        if (willDelete) {
                            const payload = {
                                ROWID: Rowid,
                                DELETEDBY  : userInfo.email_id
                            };
                            AwsServerService.DeleteProfile(payload).then((res) => {
                                const rows = res?.data?.data;
                                if(rows?.affectedRows > 0){
                                    fetchProfiles();
                                }
                            });
                        }
                    });
                    // swal({
                    //     title: "Warning!",
                    //     text: `Are you sure you want to delete the Team?`,
                    //     icon: "warning",
                    //     buttons: {
                    //         cancel: "Cancel",
                    //         confirm: "Proceed",
                    //     },
                    // }).then(async (isDelete) => {
                    //     if (isDelete) {
                    //         AwsServerService.CrudServiceHandler({ method: "DELETE", data: Rowid, route: "TEAMS" }).then(res => {
                    //             // reloadTeams()
                    //         })
                    //     }
                    // })
                })
                btnDiv.appendChild(editBtn);
                btnDiv.appendChild(deleteBtn);
                return btnDiv;
            }
    const getUserThumbnailUrl = (zuid) => {
        const loginProfileUrl =
        "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
        return loginProfileUrl;
    };
    const profileCols = [
            {
                field: "PROFILE_NAME",
                key: "Profile_Name",
                name: "Profile Name",
                path: "Profile_Name",
                type: "text",
                label: "Profile Name",
                id: 1,
                isChecked: false,
                isDragOver: false,
                isSearch: true,
                content: profilenameCellRenderer
            },  
            {
                field: "DESCRIPTION",
                name: "Description",
                path: "Description",
                type: "text",
                // key: "UserId",
                label: "Description",
                id: 2,
                isChecked: false,
                isDragOver: false,
                isSearch: false
            },  
            {
                field: "CREATEDBY",
                name: "Created By",
                path: "CREATEDBY",
                key: "CREATEDBY",
                type: "text",
                label: "Created By",
                id: 3,
                isChecked: false,
                isDragOver: false,
                isSearch: false,
                content: (obj) => {
                    const user = AllUsers.find(u => u.email === obj.CREATEDBY);
                    if(!user?.full_name) return "N/AA"
                    const profile = getUserThumbnailUrl(user.zuid); 
                    return `
                        <span style="display:flex;align-items:center;gap:8px;">
                        <img
                            src="${profile}"
                            alt="${user?.full_name}"
                            style="width:24px;height:24px;border-radius:50%;"
                        />
                        <span>${user?.full_name}</span>
                        </span>
                    `;
                },
            },
            {
                field: "CREATEDTIME",
                name: "Created Time",
                path: "CREATEDTIME",
                // key: "CREATEDTIME",
                type: "text",
                label: "Created Time",
                id: 4,
                isChecked: false,
                isDragOver: false,
                isSearch: false,
                content: (obj) => {
                    return moment(obj?.CREATEDTIME).format('MM-DD-YYYY HH:MM');
                },
            },
            {
                field: "MODIFIEDBY",
                name: "Modified By",
                path: "MODIFIEDBY",
                key: "MODIFIEDBY",
                type: "text",
                label: "Modified By",
                id: 5,
                isChecked: false,
                isDragOver: false,
                isSearch: false,
                content: (obj) => {
                    const user = AllUsers.find(u => u.email === obj.MODIFIEDBY);
                    if(!user?.full_name) return "N/AA"
                    const profile = getUserThumbnailUrl(user.zuid); 
                    return `
                        <span style="display:flex;align-items:center;gap:8px;">
                        <img
                            src="${profile}"
                            alt="${user?.full_name}"
                            style="width:24px;height:24px;border-radius:50%;"
                        />
                        <span>${user?.full_name}</span>
                        </span>
                    `;
                },
            },
            {
                field: "MODIFIEDTIME",
                name: "Modified Time",
                path: "MODIFIEDTIME",
                // key: "MODIFIEDTIME",
                type: "text",
                label: "Modified Time",
                id: 6,
                isChecked: false,
                isDragOver: false,
                isSearch: false,
                content: (obj) => {
                    return moment(obj?.MODIFIEDTIME).format('MM-DD-YYYY HH:MM');
                },
            },
            {
                field: "MEMBERS",
                name: "Members",
                path: "Members",
                key: "Members",
                type: "text",
                label: "Members",
                id: 7,
                isChecked: false,
                isDragOver: false,
                isSearch: true,
                content: (obj) => {
                const emails = obj?.EMAILS
                    ? obj.EMAILS.split(',')
                    .map(email => {
                        const key = email.trim().toLowerCase();
                        return key;
                        // return userMap[key] || email.trim();
                    })
                : [];
                let avatarsHtml = "";
                for (const em of emails) {
                    const email = typeof em === "string"
                        ? em.toLowerCase()
                        : em.toLowerCase();
                    if (!email) continue;

                    const user = AllUsers.find(
                        us => us.email?.toLowerCase() === email
                    );

                    if (!user?.zuid) continue;

                    const profile = getUserThumbnailUrl(user.zuid);
                    const title = user.full_name || email;
                    avatarsHtml += `
                    <img
                        src="${profile}"
                        title="${title}"
                        style="
                        width:24px;
                        height:24px;
                        border-radius:50%;
                        object-fit:cover;
                        margin-right:6px;
                        "
                    />
                    `;
                }

                return `
                    <span style="display:flex;align-items:center;">
                    ${avatarsHtml}
                    </span>
                `;
                },
            },
            {
                field: "Action",
                key: "Action",
                name: "Action",
                path: "Action",
                type: "text",
                label: "Action",
                id: 8,
                isChecked: false,
                isDragOver: false,
                isSearch: true,
                content: actionListCellRenderer,
            },
        ];
const handleChange = (field, value) => { 
    setOpenCreateModal(prev => ({
        ...prev,
        data: {
            ...prev.data,
            [field]: value,
        },
    }));
    };
  const handleSubmit = () => {
    if (!openCreateModal.data.PROFILE_NAME.trim()) {
        message.error("Profile name is required!");
        return;
    }
    if(openCreateModal.type == "create"){
        const clonedProfile = openCreateModal.data.cloneProfile
            ? profilesData.find(
                profile => profile.PROFILE_NAME === openCreateModal.data.cloneProfile
            ) : null;
        const payload = {
            ...openCreateModal.data,
            PROFILE_NAME: openCreateModal.data.PROFILE_NAME,
            CREATEDBY  : userInfo.email_id,
            MODULE_PERMISSIONS : clonedProfile?.MODULE_PERMISSIONS ?? null,
            FIELD_PERMISSIONS : clonedProfile?.FIELD_PERMISSIONS ?? null,
            USER_PERMISSIONS : clonedProfile?.USER_PERMISSIONS ?? null,
        };
        AwsServerService.AddProfile(payload).then((res)=>{
            const rows = res?.data?.data;
            if(rows?.insertId > 0){
                fetchProfiles();
                setOpenCreateModal({data:{PROFILE_NAME:'',DESCRIPTION:'',cloneProfile:''},open:false,type:"create"});
            }
        })
    }else if(openCreateModal.type == "edit"){
        const payload = {
            ...openCreateModal.data,
            PROFILE_NAME: openCreateModal.data.PROFILE_NAME,
            MODIFIEDBY  : userInfo.email_id
        };
        AwsServerService.UpdateProfile(payload).then((res)=>{
            const rows = res?.data?.data;
            if(rows?.affectedRows > 0){
                fetchProfiles();
                setOpenCreateModal({data:{PROFILE_NAME:'',DESCRIPTION:'',cloneProfile:''},open:false,type:"create"});
            }
        })
    }
}
        const CreateProfile = () => {
            return <Modal 
           rootClassName='Profile-modal'
           destroyOnHidden={true}
           title={openCreateModal?.type == "edit" ? "Edit Profile" : "Create Profile"}
           onCancel={()=>setOpenCreateModal({data:{PROFILE_NAME:'',DESCRIPTION:'',cloneProfile:''},open:false,type:"create"})}
           open={openCreateModal?.open}
           maskClosable={false}
           footer={[
            <Button type='default' onClick={()=>setOpenCreateModal({data:{PROFILE_NAME:'',DESCRIPTION:'',cloneProfile:''},open:false,type:"create"})}>Cancel</Button>,
            <Button type='default' onClick={()=>handleSubmit()}>
                {openCreateModal?.type=='create'?'Create':'Update'}</Button>
           ]}
        >
            <div className='CreateTeamContainer'>
            <Row style={{marginBottom:'6px'}}>
                <Col sm={5}>
                    <label style={{color: "#5B6C97", fontWeight: '500'}}>Profile Name :</label>
                </Col>
                <Col sm={18}> 
                <Input
                    placeholder="Enter profile name..."
                    value={openCreateModal.data.PROFILE_NAME}
                    onChange={(e) => {
                        e.currentTarget.value = e.currentTarget.value.trimStart().replace(/[^a-zA-Z0-9 ]/g, '');                        ;
                        handleChange('PROFILE_NAME', e.currentTarget.value)
                    }}
                />
                </Col>
            </Row>    
            <Row style={{marginBottom:'6px'}}>
                <Col sm={5}>
                    <label style={{color: "#5B6C97", fontWeight: '500'}}>Description :</label>
                </Col>
                <Col sm={18}> 
                <TextArea
                    maxLength={200}
                    placeholder="Enter text..."
                    value={openCreateModal.data.DESCRIPTION}
                    onChange={(e) => {
                        e.currentTarget.value = e.currentTarget.value.trimStart().replace(/[^a-zA-Z0-9 ]/g, '');                        ;
                        handleChange('DESCRIPTION', e.currentTarget.value)
                    }}
                />
                </Col>
            </Row>  
            {openCreateModal.type == "create" && 
            <Row style={{marginBottom:'5px'}}>
                <Col sm={5}>
                    <label style={{color: "#5B6C97", fontWeight: '500'}}>Clone Profile :</label>
                </Col>
                <Col sm={18}> 
                <Select 
                   rootClassName='AppProfilesSelect'
                   value={openCreateModal.data.cloneProfile}
                   placeholder="Select a profile to clone..."
                   options={profilesData.map(profile=>({label:profile.PROFILE_NAME,value:profile.PROFILE_NAME}))}
                   onChange={(value)=>handleChange('cloneProfile',value)}
                />
                </Col>
            </Row>} 
            </div>
        </Modal>  
        }

         const extraComponentToRightForUserRole = (e) => {
                return (
                    <div className="extra-component-request-toRight">
                        <div className="job-action-box">
                            <Button
                                type='primary'
                                className="mr-3 request-btns"
                                onClick={() => {
                                    setOpenCreateModal({data: {Name:'',DESCRIPTION:'',cloneProfile:''}, open: true, type: "create" });
                                }}
                            >
                                Create Profile
                            </Button>
                        </div>
                    </div>
                );
            }


return (
  <>
    {CreateProfile()}

    {isEditProfileAccess.isTrue ? (
      <ModulePermissions
        setIsEditProfileAccess={setIsEditProfileAccess}
        isEditProfileAccess={isEditProfileAccess}
        profilesData={profilesData}
      />
    ) : (
       <Tabs
          activeKey={activeTab}          // controlled active tab
          onChange={(key) => setActiveTab(key)}
          type="card"
          rootClassName="custom-tabs"
        >
        {/* Tab 1: Profiles Table */}
        <TabPane tab="Application Profiles" key="1">
          <div id="myGrid" className='ag-theme-alpine Blueprint-Body'>
            <GlobalAgGridTable
              headers={profileCols}
              setRowData={setProfilesData}
              cacheRowData={cacheProfilesData}
              setCacheRowData={setCacheProfilesData}
              module="Security Control"
              mainUrl="SecurityControl" 
              rowData={profilesData}
              renderExtraComponent={() => <></>}
              renderExtraComponentToRight={extraComponentToRightForUserRole}
              isTaskFilterHide={true}
            />
          </div>
        </TabPane>
        {/* Tab 2: RolesHierarchy */}
        <TabPane tab="Roles and Sharing" key="2">
          <RolesHierarchy />
        </TabPane>
      </Tabs>
    )}
  </>
);

}
